import React from 'react'

type Props = {
  color: string
}

const CartIcon = (props: Props) => (
  <svg width='25px' height='21px' viewBox='0 0 25 21' version='1.1' xmlns='http://www.w3.org/2000/svg'>
    <defs>
      <polygon id='path-1' points='0.0386645963 0.112973913 2.87360248 0.112973913 2.87360248 2.89130435 0.0386645963 2.89130435' />
      <polygon id='path-3' points='0.0102950311 0.112973913 2.8453882 0.112973913 2.8453882 2.89130435 0.0102950311 2.89130435' />
    </defs>
    <g id='Desktop' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='3' transform='translate(-980.000000, -15.000000)'>
        <g id='Group-8' transform='translate(980.000000, 15.000000)'>
          <g id='Group-5'>
            <g id='Group-4'>
              <g id='Group-2'>
                <g id='Group'>
                  <g id='Group-9'>
                    <g id='Group-7' transform='translate(9.316770, 18.097739)'>
                      <g id='Group-3'>
                        <mask id='mask-2' fill='white'>
                          <use xlinkHref='#path-1' />
                        </mask>
                        <g id='Clip-2' />
                        <path d='M1.4560559,0.112973913 C0.673291925,0.112973913 0.0386645963,0.73506087 0.0386645963,1.50232174 C0.0386645963,2.26958261 0.673291925,2.89136522 1.4560559,2.89136522 C2.23897516,2.89136522 2.87360248,2.26958261 2.87360248,1.50232174 C2.87360248,0.73506087 2.23897516,0.112973913 1.4560559,0.112973913' id='Fill-1' fill={props.color} mask='url(#mask-2)' />
                      </g>
                      <g id='Group-6' transform='translate(6.832298, 0.000000)'>
                        <mask id='mask-4' fill='white'>
                          <use xlinkHref='#path-3' />
                        </mask>
                        <g id='Clip-5' />
                        <path d='M1.42768634,0.112973913 C0.64507764,0.112973913 0.0102950311,0.73506087 0.0102950311,1.50232174 C0.0102950311,2.26958261 0.64507764,2.89136522 1.42768634,2.89136522 C2.21060559,2.89136522 2.8453882,2.26958261 2.8453882,1.50232174 C2.8453882,0.73506087 2.21060559,0.112973913 1.42768634,0.112973913' id='Fill-4' fill={props.color} mask='url(#mask-4)' />
                      </g>
                    </g>
                    <polygon id='Fill-8' fill={props.color} points='3.39819876 0.152067391 3.37413043 0.159219565 6.21118012e-05 0.159219565 6.21118012e-05 1.2702413 2.64229814 1.2702413 9.07040373 16.8278935 9.07195652 16.827437 9.07195652 16.8291109 19.2778571 16.8291109 19.2778571 15.7174804 9.82940994 15.7174804 8.91093168 13.4945239 20.4117081 13.4945239 20.4121739 13.4949804 24.9477329 3.49563261 24.9477329 3.49532826 24.9359317 3.49304565 24.9475776 3.49304565 24.9475776 2.38156739 4.31947205 2.38156739 3.40192547 0.161045652 3.40192547 0.159219565 3.40114907 0.159219565' />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default CartIcon
